import React, { useMemo } from 'react'
import Common from './common/TripsGrid'
import Zuiderhuis from './zuiderhuis/TripsGrid'
import LaplandTravel from './laplandtravel/TripsGrid'
import Travelbase from './travelbase/TripsGrid'
import Zoover from './zoover/TripsGrid'
import Holapola from './holapola/TripsGrid'
import Tourtailors from './tourtailors/TripsGrid'
import Neckermann from './neckermann/TripsGrid'

const TripsGridLoader = ({
  id,
  items,
  title,
  isLessThanLaptop,
  router,
  language,
  random_match,
  showRelevancyInfo,
  organizationSlug,
  itemsPerRow,
  itemsPerPage,
  isChatMode,
}) => {
  // Memoize the lazy-loaded component based on organizationSlug
  const TripGridLazyLoaded = useMemo(() => {
    if (!organizationSlug) return null
    switch (organizationSlug) {
      case 'zuiderhuis':
        return Zuiderhuis
      case 'laplandtravel':
        return LaplandTravel
      case 'travelbase':
        return Travelbase
      case 'zoover':
        return Zoover
      case 'holapola':
        return Holapola
      case 'tourtailors':
        return Tourtailors
      case 'neckermann':
        return Neckermann
      default:
        return Common
    }
  }, [organizationSlug])

  return (
    <>
      <TripGridLazyLoaded
        id={id}
        title={title}
        items={items}
        random_match={random_match}
        isLessThanLaptop={isLessThanLaptop}
        router={router}
        language={language}
        showRelevancyInfo={showRelevancyInfo}
        organizationSlug={organizationSlug}
        itemsPerRow={itemsPerRow}
        itemsPerPage={itemsPerPage}
        isChatMode={isChatMode}
      />
    </>
  )
}

export default TripsGridLoader
